import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-healthlist',
  templateUrl: './healthlist.component.html',
  styleUrls: ['./healthlist.component.scss']
})
export class HealthlistComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
